import React from "react";
import {Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import Button from "@mui/material/Button";
import {routes} from "../routes";
import './DatasetUpdatedLandingPage.scss';

export const DatasetUpdatedLandingPage: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className="dataset-updated-landing-page">
            <Grid container justifyContent="center">
                <Grid>
                    <Typography variant="h3" component="h1">
                        Link expired!
                    </Typography>
                    <Typography variant="body2" component="h3">
                        Your data's refreshed, please go back to the home page and try again.
                    </Typography>
                    <Button variant="contained" color="primary" onClick={() => navigate(routes.home)}>
                        Back to home
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};
